import { Component } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseListComponent } from "../base/base-list.component";

@Component({
    selector: 'app-funcionalidade',
    templateUrl: './funcionalidade.component.html',
})
export class FuncionalidadeComponent extends BaseListComponent {
    controllerName = 'funcionalidade';
    listaSistema:any[] = [];
    listaSituacao:any[] = [];
    filtro = this.formBuilder.group({
      possui: [null],
      nome: [null],
      codigo: [null],
      id_sistema: [null],
      id_situacao: [null],
      tipo: [null]
    });
 
    init(){
      if(sessionStorage.getItem("msg") !== null){
        super.showMsg('success', 'Mensagem de Sucesso', sessionStorage.getItem("msg"))
      }
      this.listagem.pDatatableComponent.sortOrder = 2;
      sessionStorage.removeItem("msg");
  
      this.service.ListarTodos('sistema',{id_situacao:1}).subscribe(x => {
        this.listaSistema = x;
      });
      this.service.ListarTodos('combo/situacao').subscribe(x => {
        this.listaSituacao = x;
      });
    }
}


// WEBPACK FOOTER //
// ./src/app/funcionalidade/funcionalidade.component.ts